import { createContext, useContext } from 'react';
import { FieldContext as TFieldContext } from './types';

export const FieldContext = createContext<TFieldContext>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  null as any,
);

export const useField = () => useContext(FieldContext);
